module.exports = ".mobilemenuicon {\n  margin: 18px;\n  width: 30px;\n  float: right; }\n\n.menuicon {\n  width: 30px;\n  cursor: pointer; }\n"


//////////////////
// WEBPACK FOOTER
// ./src/app/header/header.component.scss
// module id = ./src/app/header/header.component.scss
// module chunks = main